module.exports = __webpack_public_path__ + "static/media/map.1c97b884.png";